import { Link, Typography } from "@material-ui/core";
import React from 'react';

const Index = () => {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://venuxx.com">
      Venuxx
      </Link>
      {` 2001-${new Date().getFullYear()}`}
      {` - versão 3.4.0`}
    </Typography>
  );
}

export default Index
